import {SmallGreyButton} from "../../../../misc/SmallGreyButton";
import React, {useState} from "react";
import {
    Alert, AlertTitle,
    Checkbox,
    DialogContent,
    DialogContentText,
    DialogTitle,
    FormControlLabel
} from "@mui/material";
import {Dialog2} from "../../../../misc/Dialog2";
import {SmoothActionBar} from "../../../../misc/SmoothActionBar";
import {AutoComplete} from "../openings/AutoComplete";
import {Alternative} from "../../../../api/QuoteAlternatives";
import {getAll} from "../../../logistics/routes/useGetAll";
import {api} from "../../../../api/API";
import {useProjectId} from "../ProjectName";
import {useAsyncAction} from "nate-react-api-helpers";
import {useReloader} from "./ReloadContext";
import {useSyncedRef} from "../../../../misc/SyncedRef";

export function CopyHardwareFromQuoteMode() {
    const [show, setShow] = useState(false)

    return (
        <>
            <SmallGreyButton onClick={() => setShow(true)}>
                Copy from Quote Mode
            </SmallGreyButton>
            {show && <CopyHardwareDialog onClose={() => setShow(false)} />}
        </>
    )
}

export function CopyHardwareDialog(props: {
    onClose(): void;
}) {
    const project = useProjectId();
    const [alternative, setAlternative] = useState<Alternative|null>(null);
    const reloadRef = useReloader();
    const onCloseRef = useSyncedRef(props.onClose);

    const action = useAsyncAction(async (input) => {
        await api.hardware.overwriteFromQuoteMode(input);
        reloadRef.current();
        onCloseRef.current();
    }, []);

    const [autoFix, setAutoFix] = useState(false);

    return (
        <Dialog2 open onClose={() => props.onClose()}>
            <DialogTitle>
                Copy Hardware from Quote Mode
            </DialogTitle>
            <DialogContent>
                <div style={{height: 8}}/>

                <DialogContentText>
                    This will overwrite the current hardware with the hardware from the quote alternative selected.
                </DialogContentText>

                <div style={{height: 8}}/>

                <AutoComplete<Alternative>
                    fullWidth
                    label="Choose Alternative"
                    search={async input => {
                        let result = await getAll(null, offset => api.quoteAlternatives.list({
                            project: project,
                            offset: offset,
                        }), {useLazy: true})

                        if (input !== "") {
                            input = input.toLowerCase();
                            result = result.filter(r => r.name.toLowerCase().indexOf(input) !== -1)
                        }

                        return result;
                    }}
                    value={alternative}
                    equals={(a, b) => a.id === b.id}
                    makeLabel={a => a.name}
                    onSelect={setAlternative}
                />

                <div style={{height: 16}}/>
                {action.error && <Alert severity="warning">
                    <AlertTitle>Auto-Fix</AlertTitle>
                    <FormControlLabel control={<Checkbox checked={autoFix} onChange={(v, checked) => {
                        setAutoFix(checked)
                    }} />} label="Auto-fix conflicts by creating multiple groups/shortcodes" />
                    <div style={{height: 16}}/>
                </Alert>}

            </DialogContent>
            <SmoothActionBar
                loading={action.loading}
                error={action.error}
                actionName="Overwrite & Copy"
                submitDisabled={!alternative}
                onCancel={() => props.onClose()}
                onSubmit={() => {
                    action.callback({
                        project: project,
                        alternative: alternative!.id,
                        autoFix,
                    })
                }}
            />
        </Dialog2>
    )
}